import formItemClickForGroup from './formItemClickForGroup.vue'
export default formItemClickForGroup
